import { AppConfigService } from 'src/app/shared/services/app-config.service';
// import { UserSelectors } from './../store/features/users.feature';
// import { AppConfigService } from "./../../services/app-config.service";
import { Observable, Subject, of } from "rxjs";
import { ApiService } from "src/app/shared/services/api.service";
import { Injectable } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { environment } from "src/environments/environment";
import { map, retry, tap } from "rxjs/operators";
// import { Store } from "@ngrx/store";
// import { AppState } from "../store/app.state";

@Injectable({
  providedIn: "root",
})
export class ProfileService {

  get identity(): Identity {
    return this.oAuthService.getIdentityClaims() as Identity;
  }
  get profile(): Profile {
    const profile = window.localStorage.getItem("profile");
    return JSON.parse(profile || "{}");
  }
  set profile(val: Profile) {
    window.localStorage.setItem("profile", JSON.stringify(val));
  }
  get role() {
    const identity = this.oAuthService.getIdentityClaims() as Identity;
    if (identity) {
      return identity.userType;
    }
    return null;
  }

  get isStaff() {
    if (this.profile.role == 'Parent' || this.profile.role == 'Student') {
      return false
    } else {
      return true
    }
  }

  get userId(): string {
    return this.identity.userIdRole
  }

  // user$ = this.store.select(UserSelectors.ActiveProfileSelect)

  baseUrl: string = this.appConfig.appConfig?.environment.endPoints.customerServices!;

  public pictureUpdate: Subject<any> = new Subject<any>();
  constructor(
    private oAuthService: OAuthService,
    private api: ApiService,
    private oauthService: OAuthService,
    private appConfig: AppConfigService
    // private store:Store<AppState>
  ) {

  }
  getProfile(): Observable<Profile> {
    const path = `${this.baseUrl}/v1/profile/${this.identity.userIdRole}`;

    var token = this.oauthService.getAccessToken()
    return this.api
      .getWithHeaders(path,{
        'Authorization':'Bearer '+token
      })
      .pipe(
        tap((response) => {
          this.profile = response as Profile;
        }),
        map((response) => response as Profile));


    // return this.api.getNoCache(path).pipe(
    //   tap((response) => {
    //     this.profile = response as Profile;
    //   }),
    //   map((response) => response as Profile)
    // );
  }
  getProfileAsLogin(): Observable<Profile> {
    const path = `${this.baseUrl}/v1/profile/${this.identity.userIdRole}?isLogin=true`;
    return this.api.getNoCache(path).pipe(
      tap((response) => {
        this.profile = response as Profile;
      }),
      map((response) => response as Profile)
    );
  }
  // getProfileById(id: any,cache:boolean = true): Observable<Profile> {
  //   const path = `${this.baseUrl}/v1/profile/${id}`;
  //   var token = this.oauthService.getAccessToken()

  //   if(cache){
  //     return this.api.cached(path,{ spinner: "no" }).pipe(map((response) => response as Profile));
  //   }else{
  //     return this.api
  //     .getWithHeaders(path,{
  //       'Authorization':'Bearer '+token
  //     })
  //     .pipe(map((response) => response as Profile));
  //   }

  // }
  getSmallProfileById(id: any): Observable<Profile> {
    const path = `${this.baseUrl}/v1/profile/${id}`;
    var token = this.oauthService.getAccessToken()


    return this.api
      .getWithHeaders(path, {
        'Authorization': 'Bearer ' + token
      })
      .pipe(map((response) => response as Profile));

  }
  getProfileById(id: any): Observable<Profile> {
    const path = `${this.baseUrl}/v1/profile/${id}`;
    var token = this.oauthService.getAccessToken()


    return this.api
      .getWithHeaders(path, {
        'Authorization': 'Bearer ' + token
      })
      .pipe(map((response) => response as Profile));

  }


  isParent() {
    return this.role === 'Parent' ? true : false;
  }

  cachedProfiles = []
  silentProfileById(id: any): Observable<Profile> {
    const path = `${this.baseUrl}/v1/profile/${id}`;


    return this.api
      .cached(path, { spinner: "no" })
      .pipe(map((response) => response as Profile));
  }

  getContactProfile(usernameNo: string): Observable<Profile> {
    const path = `${this.baseUrl}/v1/profile/${usernameNo}`;
    if (this.profile.usernameNo) {
      return of(this.profile);
    }
    return this.api.get(path).pipe(
      tap((response) => {
        this.profile = response as Profile;
      }),
      map((response) => response as Profile)
    );
  }
  saveProfile(profile: any): Observable<any> {
    const path = `${this.baseUrl}/v1/profile/${this.identity.userIdRole}`;
    var token = this.oauthService.getAccessToken()
    return this.api
      .patchHeader(path, profile, {
        'Authorization':'Bearer '+token
      })
      .pipe(map((response) => response as any));
  }
  saveProfileAvatar(profile: any): Observable<any> {
    const path = `${this.baseUrl}/v1/profile/${this.identity.userIdRole}/mobile-avatar`;
    var token = this.oauthService.getAccessToken()
    return this.api
      .postHeaders(path, profile, {
        'Authorization':'Bearer '+token
      })
      .pipe(map((response) => response as any));
  }
  setTheme(theme: any) {
    const path = `${this.baseUrl}/v1/profile/${this.identity.userIdRole}/theme`;
    return this.api.patch(path, theme).pipe(map((response) => response as any));
  }
  getTheme() {
    const path = `${this.baseUrl}/v1/profile/${this.identity.userIdRole}/theme`;
    return this.api.get(path).pipe(map((response) => response as any));
  }
  // uploadAvatar(profileId: any, file: File, avatar:string):Observable<any> {
  //   let path = `${this.baseUrl}/v1/profile/${profileId}/avatar`;
  //   return this.api.postFile(path,{
  //     previousAvatar: avatar
  //   },file).pipe(map((response)=> response as any));
  // }
  parseJwt(token: string) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };
}
export interface Identity {
  nbf: number;
  exp: number;
  iss: string;
  aud: string;
  nonce: string;
  iat: number;
  at_hash: string;
  s_hash: string;
  sid: string;
  sub: string;
  auth_time: number;
  idp: string;
  usernameNo: string;
  displayName: string;
  userType: string;
  userIdRole: string;
  amr: string[];
}
export interface Profile {
  lastLogin: any;
  role: string;
  id: string;
  picture: string;
  firstName: string;
  lastName: string;
  middleName: string;
  fullName: string;
  email: string;
  bio: string;
  url: string;
  language: string;
  nickname: string;
  handbook: boolean;
  hasTour: boolean;
  notification: NotificationGroup;
  userType: string;
  usernameNo: string;
  themeSettings: any;
  avatar: any;
  accountEnabled: boolean;
  studentExceptionEnabled: boolean;
}
export interface NotificationGroup {
  feedCount: number;
  messageCount: number;
  commentCount: number;
}
